import { Col, Row } from 'react-bootstrap'
import classNames from 'classnames'
import { useTags } from 'components/ui/CourseTags/useTags'
import { ICourseCard } from 'models/courseCard.model'
import { IEnrolCard } from 'models/enrolCard.model'
import styles from './Tags.module.scss'

interface TagsProps {
  course: ICourseCard
  enrol: IEnrolCard | null
}

export * from '../../../../CourseTags/useTags/constants'

export function Tags({ course, enrol }: TagsProps) {
  const tags = useTags({ course, enrol })

  return (
    <div className={styles.rootAbsolute}>
      <Row>
        {tags.map((tag, index) => (
          <Col xs="auto" className="d-flex justify-content-end" key={index}>
            <div className={classNames(styles.tag, 'my-1')}>{tag}</div>
          </Col>
        ))}
      </Row>
    </div>
  )
}
